import { Injectable } from '@angular/core';
import { Http, Response, RequestOptions, RequestOptionsArgs, Headers } from '@angular/http';
import { HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, catchError } from "rxjs/operators";
import { importType } from '@angular/compiler/src/output/output_ast';
import { GlobalVariable } from "src/app/globals";
import { AuthenticateService } from './authenticate.service';

@Injectable()


export class SprintService {
    private baseApiUrl = GlobalVariable.BASE_API_URL;
    constructor(
        private http: Http,
        private authService: AuthenticateService
    ) { }


    addTask(task) {
    let options = this.authService.setHeaderAuth();
    let request = this.baseApiUrl + 'api/tasks/postSprint';
    return this.http.post(request, task, options).pipe(
      map(
        response => {
          return response.json()
        }
      ),
      catchError(err => {
        return "error";
      }
      )
    );
  }

    getSprintList(pageNumber, pageSize, sortBy, sortOrder, id) {
    let options = this.authService.setHeaderAuth();
    let request = this.baseApiUrl + `api/tasks/GetSprint?pageNumber=${pageNumber}&pageSize=${pageSize}&sortBy=${sortBy}&sortOrder=${sortOrder}&userId=${id}`;
    return this.http.get(request, options).pipe(
      map(
        response => {
          return response.json()
        }
      ),
      catchError(err => {
        return "error";
      }
      )
    );
  }

   getSprintCommentList(pageNumber, pageSize, sortBy, sortOrder) {
    let options = this.authService.setHeaderAuth();
    let request = this.baseApiUrl + `api/tasks/getSprintComment?pageNumber=${pageNumber}&pageSize=${pageSize}&sortBy=${sortBy}&sortOrder=${sortOrder}`;
    return this.http.get(request, options).pipe(
      map(
        response => {
          return response.json()
        }
      ),
      catchError(err => {
        return "error";
      }
      )
    );
  }
}